function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

function Check(props) {
  const {
    width,
    height,
    size,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size || width,
    height: size || height,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M1.12 5.51a.559.559 0 01.832-.101l2.201 1.953-.427.624a.326.326 0 01-.486.06L1.21 6.245a.559.559 0 01-.09-.734z",
    fill: "#96DFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.883 1.087c.043.03.053.09.023.132L3.669 7.132l-.154-.105L7.754 1.11a.093.093 0 01.129-.023z",
    fill: "#C4C4C4",
    stroke: "#96DFCD"
  }));
}

Check.defaultProps = {
  width: 9,
  height: 9
};
export default Check;